export default {
    difficulties: [
        {
            name: '2x3',
            rows: 2,
            columns: 3,
            level: 1,
        },
        {
            name: '3x3',
            rows: 3,
            columns: 3,
            level: 2,
        },
        {
            name: '3x4',
            rows: 3,
            columns: 4,
            level: 3,
        },
        {
            name: '4x4',
            rows: 4,
            columns: 4,
            level: 4,
        },
        {
            name: '5x5',
            rows: 5,
            columns: 5,
            level: 5,
        },
        {
            name: '6x6',
            rows: 6,
            columns: 6,
            level: 6,
        },
    ],
};
